<template>
  <div class="smy__card-full-box">
    <div class="search-top-right">
      <Poptip placement="bottom-end" width="1200" word-wrap>
        <Button type="default" class="search-button">
          筛选列
          <Icon type="arrow-down-b"></Icon>
        </Button>
        <div class="content" slot="content">
          <CheckboxGroup class="filter-column" v-model="curcodeList">
            <Checkbox
              v-for="item in columnsChecked"
              :key="item.code"
              class="smy-column"
              :label="item.code"
            >
              {{ item.name }}
            </Checkbox>
          </CheckboxGroup>
          <div
            style="
              border-top: 1px solid #e9e9e9;
              margin-bottom: 1px;
              padding-top: 6px;
              margin-top: 6px;
            "
          >
            <Checkbox
              :indeterminate="
                curcodeList.length > 0 &&
                curcodeList.length < columnsChecked.length
              "
              :value="curcodeList.length === columnsChecked.length"
              @click.prevent.native="columnsCheckedChange"
            >
              全选
            </Checkbox>
          </div>
        </div>
      </Poptip>
    </div>
    <div class="button-group">
      <Button-group>
        <i-button
          :type="process_state === 0 ? 'primary' : 'ghost'"
          @click="PCModuleDeal"
        >
          PC模块
        </i-button>
        <i-button
          :type="process_state === 1 ? 'primary' : 'ghost'"
          @click="PCFuncDeal"
        >
          PC功能
        </i-button>
        <i-button
          :type="process_state === 2 ? 'primary' : 'ghost'"
          @click="MModuleDeal"
        >
          M模块
        </i-button>
        <i-button
          :type="process_state === 3 ? 'primary' : 'ghost'"
          @click="MFuncDeal"
        >
          M功能
        </i-button>
      </Button-group>
    </div>
    <!-- 工单列表 -->
    <div class="table table-sticky">
      <Table
        stripe
        ref="table"
        :loading="listLoading"
        :columns="columns"
        :data="list"
      ></Table>
    </div>
    <!-- 分页控件 -->
    <Page
      show-total
      show-sizer
      class="page"
      placement="top"
      :current="pageIndex + 1"
      :total="count"
      :page-size-opts="pageSizeOpts"
      @on-change="pageIndexChange"
      @on-page-size-change="pageSizeChange"
    ></Page>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { moduleMapping, funcMapping } from '@/constant/index'
export default {
  components: {},
  props: {
    opId: {
      type: Number,
    },
  },
  data() {
    return {
      // 筛选列
      columnsChecked: [],
      curcodeList: [],
      funcList: [],
      moduleList: [],
      funccodeList: [],
      modulecodeList: [],
      emptyDate: ['', ''],
      chouseState: '',
      currPackageId: 1,
      buyPeople: '',
      busType: '',
      corpid: '',
      type: 1,
      searchVisible: true, // 是否显示详细筛选条件
      pageSize: 10,
      pageIndex: 0,
      listLoading: false, // 表格加载状态
      count: 0,
      list: [],
      process_state: 0,
      searchForm: {
        channel: 1, // 中断类型 1代表PC 2代表手机端
      },
      agentId: 1,
      followUpRecModal: false,
      editTitle: '编辑联系人',
      editRow: {},
      editModal: false,
      curlisturl: '/point/module',
      curcounturl: '/point/modulecount',
      curmoduleMapping: moduleMapping, // 当前选择的是功能还是模块 0代表模块 1代表功能
    }
  },
  computed: {
    ...mapState('table', ['columnsCheckedAll', 'pageSizeOpts']),
    ...mapState('followCustom', ['id']),
    // 表格列 根据选中的列动态生成
    columns() {
      let extraColumns = []
      for (let key in this.curmoduleMapping) {
        let tem = {}
        let filterflag = this.curcodeList.indexOf(key)

        if (filterflag === -1) {
          continue
        }
        tem['title'] = this.curmoduleMapping[key]
        tem['key'] = 'list'
        tem['width'] = 180
        tem['sortable'] = true
        tem['render'] = (h, { row }) => {
          let modules = row.list
          let count = ''
          let newmoudule = modules.filter((item) => {
            if (item['name'] === key) {
              return item
            }
          })
          if (newmoudule.length > 0) {
            count = parseInt(newmoudule[0].oper_count)
          } else {
            count = 0
          }

          return h('span', [count])
        }
        extraColumns.push(tem)
      }

      let allColumns = [
        {
          title: '日期',
          key: 'counttime',
          width: 180,
          sortable: true,
        },
      ]
      allColumns = allColumns.concat(extraColumns)
      return allColumns
    },
  },
  watch: {
    chouseState(val) {},
  },
  methods: {
    columnsCheckedChange() {
      if (this.curcodeList.length === 0) {
        this.curcodeList =
          [0, 2].indexOf(this.process_state) !== -1
            ? this.modulecodeList
            : this.funccodeList
      } else {
        this.curcodeList = []
      }
    },

    // 加载列表数据
    loadList() {
      this.listLoading = true
      this.$http
        .all([
          this.$http.get(this.curlisturl, {
            params: {
              pageIndex: this.pageIndex,
              pageSize: this.pageSize,
              ...this.searchForm,
              epid: this.id, // 企业id
            },
          }),

          this.$http.get(this.curcounturl, {
            params: {
              ...this.searchForm,
              epid: this.id,
            },
          }),
        ])
        .then(
          this.$http.spread((res1, res2) => {
            if (this.curlisturl === '/point/module') {
              this.curmoduleMapping = moduleMapping
            } else {
              this.curmoduleMapping = funcMapping
            }
            if (res1.success && res2.success) {
              this.list = res1.data
              this.count = res2.data
              this.listLoading = false
            }
          })
        )
    },
    // 分页 每页大小 改变回调
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    // 分页 页码 改变回调
    pageIndexChange(pageIndex) {
      this.pageIndex = pageIndex - 1
      this.loadList()
    },

    // PC模块
    PCModuleDeal() {
      this.curcodeList = this.modulecodeList
      this.columnsChecked = this.moduleList
      this.searchForm.channel = 1
      this.process_state = 0
      this.curlisturl = '/point/module'
      this.curcounturl = '/point/modulecount'
      this.loadList()
    },
    // PC功能
    PCFuncDeal() {
      this.curcodeList = this.funccodeList
      this.columnsChecked = this.funcList
      this.searchForm.channel = 1
      this.process_state = 1
      this.curlisturl = '/point/func'
      this.curcounturl = '/point/funccount'
      this.loadList()
    },

    // M模块
    MModuleDeal() {
      this.curcodeList = this.modulecodeList
      this.columnsChecked = this.moduleList
      this.searchForm.channel = 2
      this.curlisturl = '/point/module'
      this.curcounturl = '/point/modulecount'
      this.process_state = 2
      this.loadList()
    },

    // M功能
    MFuncDeal() {
      this.curcodeList = this.funccodeList
      this.columnsChecked = this.funcList
      this.searchForm.channel = 2
      this.curlisturl = '/point/func'
      this.curcounturl = '/point/funccount'
      this.process_state = 3
      this.loadList()
    },
  },
  created() {
    let temList = []
    let temcodeList = []
    for (let key in moduleMapping) {
      temcodeList.push(key)
      temList.push({
        code: key,
        name: moduleMapping[key],
      })
    }
    this.modulecodeList = temcodeList
    this.moduleList = temList
    temList = []
    temcodeList = []
    for (let key in funcMapping) {
      temcodeList.push(key)
      temList.push({
        code: key,
        name: funcMapping[key],
      })
    }
    this.funccodeList = temcodeList
    this.funcList = temList
    this.columnsChecked = this.moduleList
    this.curcodeList = this.modulecodeList
    this.loadList()
  },
}
</script>

<style lang="less" scoped>
.ivu-poptip-inner {
  overflow: auto;
}
.smy__card-full-box {
  position: relative;
  max-height: 385px;
  overflow: auto;
}
.search-top-right {
  position: absolute;
  right: 18px;

  .filter-column {
    width: 100%;
    overflow: auto;
    // flex-direction: column;
  }
  .smy-column {
    width: 19%;
  }

  .search-button {
    margin-left: 6px;
  }
}
.page {
  margin-top: 20px;
  margin-bottom: 10px;
}

.content {
  overflow: auto;
  height: 200px;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}
.button-group {
  margin-bottom: 25px;
}
</style>



// WEBPACK FOOTER //
// src/pages/customManage/followCustomList/cusFollowDetail/FollowDetailRightThree.vue